// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"648":"7c320418","968":"3d18cad5"}[chunkId] + ".chunk.css";
};